import type { ComponentPropsWithoutRef } from "react";
import { classNames } from "@/react/components/shared/BuilderUI/utils/twMergeWithCNAndPrefix";

export const BlockSectionBackground = ({
  className,
  children,
  ...rest
}: ComponentPropsWithoutRef<"div">) => (
  <div
    className={classNames(
      "wb-bg-cover wb-bg-no-repeat wb-bg-center",
      className,
    )}
    data-block-inner
    {...rest}
  >
    {children}
  </div>
);

BlockSectionBackground.displayName = "BlockSectionBackground";
